export default __webpack_public_path__ + "static/media/POLITICA_DE_PRIVACIDADE_OKAPP.aa24e07d.pdf";